import { type } from '@testing-library/user-event/dist/type';
import { supabase } from './supabaseClient';
import Cookies from 'js-cookie';

export const createChatSession = async (sessionType, newName, userId, session_id = null, parent_session = null, is_call = true) => {
  if (session_id) {

    const { data, error } = await supabase
      .from('chat_session')
      .update({ name: newName })
      .eq('id', session_id)
      .select();

    if (error) {
      console.error('Error updating chat session:', error);
      throw error;
    }
    return data;
  } else {
    const { data, error } = await supabase
      .from('chat_session')
      .insert([{ 
        name: newName, 
        user_auth: userId, 
        type: sessionType,
        parent_session: parent_session || null, // Insert parent_session if available
        is_call: is_call // Insert is_call if available
      }])
      .select();

    if (error) {
      console.error('Error creating chat session:', error);
      throw error;
    }
    return data;
  }
};

export const backupCreateChatSession = async (userId,session_id) => {
  let sessionId = Cookies.get('chat_session_id');
  if(sessionId==="undefined"){
    sessionId=null;
  }

  if (sessionId) {
    const { data: existingSession, error } = await supabase
      .from('chat_session')
      .select('id')
      .eq('id', sessionId);

    if (error) {
      console.error('Error fetching chat session:', error);
      throw error;
    }

    if (existingSession.length === 0) {
      sessionId = null; // Session does not exist, create a new one
    }
  }

  if (!sessionId) {
    console.log("inside no session");
    const { data: existingSession, errorSession } = await supabase
    .from('chat_session')
    .select('id')
    .eq('user_auth', userId);
    console.log(existingSession);

    if (existingSession.length== 0) {
      console.log("inside if")

      const { data, error } = await supabase
        .from('chat_session')
        .insert([{ user_auth: userId }])
        .select();

      if (error) {
        console.error('Error creating chat session:', error);
        throw error;
      }
      sessionId = data[0].id;
      // Cookies.set('chat_session_id', sessionId); // Set the sessionId in cookies
      Cookies.set('chat_session_id', sessionId);
    } else {

      console.log("inside else")
      sessionId = existingSession[0].id;
      // Cookies.set('chat_session_id', sessionId);  
      Cookies.set('chat_session_id', sessionId);
    }

  }

  return sessionId;
};

export const checkPreviousSession  = async (userId) => {
  try {
    let { data: chat_session, error: sessionError } = await supabase
      .from('chat_session')
      .select("id")
      .eq('user_auth', userId)
      .order('id', { ascending: false })
      .limit(1);

    // Handle errors during chat session fetch
    if (sessionError) {
      console.error('Error getting previous chat session:', sessionError);
      throw sessionError;
    }
    if (chat_session.length) {
      return chat_session[0].id;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error fetching chat session:', error);
    throw error;
  }
};

// Add a function to check the chat_session table for the current user session type
export const checkCurrentUserSession = async (name = null) => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) {
    throw error;
  }
  
  if (!session) {
    throw new Error("No session found. Please log in.");
  }

  try {
    // First, try to get existing session from cookies
    let sessionId = Cookies.get('chat_session_id');
    
    if (sessionId === "undefined") {
      sessionId = null;
    }
    
    if (sessionId) {
      // Check if the cookie session belongs to this user
      const { data: existingSession, error: sessionError } = await supabase
        .from('chat_session')
        .select('id, name')
        .eq('id', sessionId)
        .eq('user_auth', session.user.id);

      if (sessionError) {
        console.error('Error fetching chat session:', sessionError);
        throw sessionError;
      }

      if (existingSession.length > 0) {
        // Session exists and belongs to user - return it
        console.log("Found valid session in cookie:", sessionId);
        Cookies.set('chat_session_id', sessionId);
        return { 
          id: existingSession[0].id, 
          name: existingSession[0].name === null ? "Main" : existingSession[0].name 
        };
      }
      
      // Cookie session doesn't exist or doesn't belong to user - clear it
      console.log("Cookie session invalid, finding main session");
      Cookies.remove('chat_session_id');
      sessionId = null;
    }

    // Try to find a 'main' type session for this user
    const { data: chat_session, error: sessionError } = await supabase
      .from('chat_session')
      .select("id, name")
      .eq('user_auth', session.user.id)
      .eq('type', 'main')
      .order('id', { ascending: false })
      .limit(1);

    if (sessionError) {
      console.error('Error getting main session:', sessionError);
      throw sessionError;
    }

    if (chat_session.length > 0) {
      // Found existing main session
      sessionId = chat_session[0].id;
      Cookies.set('chat_session_id', sessionId);
      console.log("Found main session:", sessionId);
      return { 
        id: chat_session[0].id, 
        name: chat_session[0].name === null ? "Main" : chat_session[0].name 
      };
    }

    // No main session exists - create a new one
    console.log("No main session found, creating new one for user:", session.user.id);
    const { data: newSession, error: newSessionError } = await supabase
      .from('chat_session')
      .insert([{ 
        user_auth: session.user.id, 
        type: 'main', 
        name: 'Main Chat' 
      }])
      .select();

    if (newSessionError) {
      console.error('Error creating new chat session:', newSessionError);
      throw newSessionError;
    }
    
    sessionId = newSession[0].id;
    Cookies.set('chat_session_id', sessionId);
    console.log("Created new main session:", sessionId);
    
    return { 
      id: newSession[0].id, 
      name: newSession[0].name || 'Main Chat' 
    };
    
  } catch (err) {
    console.error('Error in checkCurrentUserSession:', err);
    throw err;
  }
};
export const getSessionType = async (sessionId) => {
  if (sessionId) {
    const { data: chatSession, error } = await supabase
      .from('chat_session') 
      .select('*')
      .eq('id', sessionId)
      .single();  

    if (error) {
      console.error('Error fetching chat session type:', error);
      throw error;
    }
    return chatSession;
  }
  return null;
};



export const isCurrentSessionSideType = async () => {
  let sessionId = Cookies.get('chat_session_id');
  if(sessionId==="undefined"){
    sessionId=null;
  }
  if (sessionId) {
    const { data: chatSession, error } = await supabase
      .from('chat_session')
      .select('type')
      .eq('id', sessionId)
      .single();

    if (error) {
     return 0;
    }
    if(!Cookies.get('is_call')){
      // alert("is_call")
      return (chatSession.type === 'topic' || chatSession.type === 'sub_topic') ? 4 : chatSession.type === 'notification'? 5 : chatSession.type === 'chatbot'? 7: 0;
    }else{
      // alert("active 2")
      return 2;
    }
  }
  return 0;
};

